const reCaptchaKeys: { [key: string]: string } = {
  'chat.avalai.ir': '6LfYCY8nAAAAAKmmJb1-dVH9QhO90s6gm8NUwK66',
  'chat.avalai.org': '6LcJjbooAAAAABUYp3nTNdx-65CKCTvyDqTIiPsS',
  'chat.avalgpt.com': '6LcJjbooAAAAABUYp3nTNdx-65CKCTvyDqTIiPsS'
};
const defaultReCaptchaV3Key = '6LfYCY8nAAAAAKmmJb1-dVH9QhO90s6gm8NUwK66';
// This module is imported by Pinia stores that are also loaded in node-based
// test harnesses (vite ssrLoadModule), so never assume `window` exists.
const currentHostname = globalThis.window?.location?.hostname ?? '';
const reCaptchaV3Key = reCaptchaKeys[currentHostname] || defaultReCaptchaV3Key;

// Base API URLs for different environments
const apiUrls = {
  production: 'https://chat.avalai.org',
  local: 'https://chat.localhost'
};

// const isViteEnvironment = typeof import.meta !== 'undefined';
// eslint-disable-next-line import/no-mutable-exports
let API_BASE_URL = apiUrls.local;

if (import.meta.env.VITE_BACKEND_ENV === 'local') {
  API_BASE_URL = apiUrls.local;
} else if (currentHostname in reCaptchaKeys) {
  API_BASE_URL = `https://${currentHostname}`;
}

export { API_BASE_URL, reCaptchaV3Key };
